import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A player-started campfire (plan 25): a ring of hearth stones around crossed
// logs with glowing embers — the STATIC half of the deployed fire (kind="fire"
// rows). The live flames are client FX (src/cookfx.ts makeFlames, appended by
// src/campfire.ts) so the deco stays snapshot-stable and the flame look stays
// shared with the cook-pan rig. Geometry only — metadata lives in
// content/decos/campfire.json; registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ blob, tube, box, seed }) => {
  const stone = shade(0x8a8079, (rand(seed) - 0.5) * 0.12);
  const bark = shade(0x5a3a22, (rand(seed + 1) - 0.5) * 0.15);

  // Ring of hearth stones (the old conjured-campfire recipe, kept verbatim so
  // a fire reads the same as it always did).
  for (let i = 0; i < 7; i++) {
    const a = (i / 7) * Math.PI * 2 + rand(seed + 2) * 0.4;
    blob(Math.sin(a) * 0.42, 0.06, Math.cos(a) * 0.42, 0.12, shade(stone, (i % 2) * 0.08));
  }

  // Crossed logs over an ash bed.
  box(0, 0.02, 0, 0.5, 0.04, 0.5, 0x33302c);            // ash
  tube(0, 0.1, 0, 0.055, 0.74, bark, "x");              // log across x
  tube(0, 0.14, 0, 0.05, 0.7, shade(bark, -0.12), "z"); // log across z

  // Glowing embers under the cross (emissive-read colors; the FLAME is client FX).
  blob(0.05, 0.08, 0.03, 0.07, 0xff7a2a);
  blob(-0.06, 0.07, -0.04, 0.05, 0xffc24a);
  blob(0.0, 0.06, -0.07, 0.04, shade(0xff7a2a, -0.15));
};

export default build;
